import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2 6.5c0-.276.236-.5.526-.5h18.948c.29 0 .526.224.526.5s-.236.5-.526.5H2.526A.514.514 0 0 1 2 6.5m0 4a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 0 1h-14a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1zm9.764 4a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1 0-1z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00B388",
      fillRule: "evenodd",
      d: "M23.84 12.386a.545.545 0 0 1 0 .771l-6.545 6.546-3.819-3.819a.545.545 0 0 1 .771-.771l3.048 3.047 5.774-5.774a.545.545 0 0 1 .771 0",
      clipRule: "evenodd"
    }
  )
);
var SvgTranscriptionReadOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TranscriptionReadOutlined_default = SvgTranscriptionReadOutlined;

export { TranscriptionReadOutlined_default as default };
